import { productClick, productView, } from './product-actions.js';
/**
 * Returns the possible product action creators.
 *
 * @returns An object holding the action creators.
 *
 * @group Actions
 * @category Product
 */
export function loadProductActions() {
    return {
        productClick,
        productView,
    };
}
